// extracted by mini-css-extract-plugin
module.exports = {"sectionHeadingText":"sectionHeading-module--sectionHeadingText--39uCD","dark":"sectionHeading-module--dark--3owWo"};